
import ModalCommonProps from '@/ui-kit/components/modal/mixins/ModalCommonProps';
import ImageGalleryModal from '@/components/image-gallery/modal';
import ListingActionsMixin from './mixins/ListingActionsMixin';
import GalleryImagesMixin from './mixins/GalleryImagesMixin';

export default {
  name: 'ListingGalleryImagesModal',
  components: {
    ImageGalleryModal,
  },
  mixins: [
    ModalCommonProps,
    ListingActionsMixin,
    GalleryImagesMixin,
  ],
  computed: {
    listing() {
      return this.modalData.listing;
    },
    $store() {
      return this.modalData.store;
    },
    modalDataWithImages() {
      return {
        ...this.modalData,
        images: this.galleryImagesSorted,
      };
    },
  },
};
